import { useState } from "react";
import type { FaqItem } from "@/mocks/faqs";

interface FaqAccordionProps {
  items: FaqItem[];
  defaultOpen?: number;
}

export default function FaqAccordion({ items, defaultOpen = 0 }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const open = openIndex === index;
        return (
          <div key={item.question}>
            <h3 className="m-0">
              <button
                type="button"
                aria-expanded={open}
                onClick={() => setOpenIndex(open ? null : index)}
                className="flex w-full items-center justify-between gap-4 py-5 text-left transition-colors hover:text-primary-700 cursor-pointer"
              >
                <span className="font-heading text-base font-bold text-foreground-950">
                  {item.question}
                </span>
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-600">
                  <i
                    className={open ? "ri-subtract-line" : "ri-add-line"}
                    aria-hidden="true"
                  />
                </span>
              </button>
            </h3>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                open ? "max-h-96 pb-5 opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <p className="pr-10 text-sm leading-relaxed text-foreground-600">
                {item.answer}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}